module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Roman.9c62dd0a.otf";